export default [
    {
        path: "/",
        meta: {
            requiresAuth: true,
            role: "admin",
            layout: "AdminLayout",
        },
        children: [
            {
                path: "/administrator-user-profile",
                component: () => import("@/Pages/Master/User/Index.vue"),
                children: [
                    {
                        path: "",
                        name: "administrator-user-profile",
                        component: () => import("@/Pages/Master/User/List.vue"),
                    },
                    {
                        path: "create",
                        name: "administrator-user-profile-create",
                        component: () =>
                            import("@/Pages/Master/User/Create.vue"),
                    },
                    {
                        path: ":id",
                        name: "administrator-user-profile-show",
                        component: () => import("@/Pages/Master/User/Show.vue"),
                    },
                    {
                        path: ":id/edit",
                        name: "administrator-user-profile-edit",
                        component: () => import("@/Pages/Master/User/Edit.vue"),
                    },
                ],
            },
            {
                path: "/administrator-role",
                component: () => import("@/Pages/Master/Role/Index.vue"),
                children: [
                    {
                        path: "",
                        name: "administrator-role",
                        component: () => import("@/Pages/Master/Role/List.vue"),
                    },
                    {
                        path: "create",
                        name: "administrator-role-create",
                        component: () =>
                            import("@/Pages/Master/Role/Create.vue"),
                    },
                    {
                        path: ":id",
                        name: "administrator-role-show",
                        component: () => import("@/Pages/Master/Role/Show.vue"),
                    },
                    {
                        path: ":id/edit",
                        name: "administrator-role-edit",
                        component: () => import("@/Pages/Master/Role/Edit.vue"),
                    },
                ],
            },
            {
                path: "/administrator-public-approval",
                component: () =>
                    import("@/Pages/AdminPublicApproval/Index.vue"),
                children: [
                    {
                        path: "",
                        name: "administrator-public-approval",
                        component: () =>
                            import("@/Pages/AdminPublicApproval/List.vue"),
                    },
                    {
                        path: ":id",
                        name: "administrator-public-approval-show",
                        component: () =>
                            import("@/Pages/AdminPublicApproval/Show.vue"),
                    },
                    {
                        path: ":id/edit",
                        name: "administrator-public-approval-edit",
                        component: () =>
                            import("@/Pages/AdminPublicApproval/Edit.vue"),
                    },
                ],
            },
            {
                path: "/admin-hotel-user",
                component: () =>
                    import("@/Pages/AdminHotel/UserApproval/Index.vue"),
                children: [
                    {
                        path: "",
                        name: "admin-hotel-user",
                        component: () =>
                            import("@/Pages/AdminHotel/UserApproval/List.vue"),
                    },
                ],
            },
            {
                path: "/administrator-job-position",
                component: () => import("@/Pages/Master/Position/Index.vue"),
                children: [
                    {
                        path: "",
                        name: "administrator-job-position",
                        component: () =>
                            import("@/Pages/Master/Position/List.vue"),
                    },
                ],
            },
            {
                path: "/administrator-activity-type",
                component: () =>
                    import("@/Pages/Master/ActivityType/Index.vue"),
                children: [
                    {
                        path: "",
                        name: "administrator-activity-type",
                        component: () =>
                            import("@/Pages/Master/ActivityType/List.vue"),
                    },
                ],
            },
            {
                path: "/administrator-officer",
                component: () => import("@/Pages/Master/Officer/Index.vue"),
                children: [
                    {
                        path: "",
                        name: "administrator-officer",
                        component: () =>
                            import("@/Pages/Master/Officer/List.vue"),
                    },
                ],
            },
        ],
    },
];
